import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NetworkCallService } from '../../core/services/network-call.service';
import { HelpersService } from '../../core/services/helpers.service';
import { of } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';
import * as proofOfBankDocumentTypesActions from '../actions/proof-of-bank-document-types.actions';
import { IStaticDataResponse } from '../models/static-data.model';

@Injectable()
export class StaticDataProofOfBankDocumentTypesEffects {
  constructor(
    private actions$: Actions,
    private networkCallService: NetworkCallService,
    private helpers: HelpersService
  ) {}

  loadProofOfBankDocumentTypes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(proofOfBankDocumentTypesActions.loadProofOfBankDocumentTypes),
      switchMap(() =>
        this.networkCallService.get<IStaticDataResponse[]>(
          'StaticData/ProofOfBankDocumentTypes'
        ).pipe(
          map(response => proofOfBankDocumentTypesActions.loadProofOfBankDocumentTypesSuccess({ response })),
          catchError(error => {
            return of(proofOfBankDocumentTypesActions.loadProofOfBankDocumentTypesFailure({ error }));
          })
        )
      )
    )
  );
}